<div *ngIf="permissionsService.isNetworkStructureCreateEditAllowed" class="d-flex flex-column justify-content-center align-items-center gap-2">
    <img src="../../../../assets/icons/v3-bps/ns-menu.svg" />
    <p>Select or create {{titleText}} to get started.</p>
    <button (click)="onAction()">Add {{buttonText}}</button>
</div>